<div class="dialog-container">
  <div class="dialog-header2">
    <div class="user-edit-icon">
      <img src="assets/images/health/icons/dtopico/Group 15.svg" class="add-icon" alt="User Icon" />
    </div>
    <div class="header-text">
      <h2 class="addmed">Add Manual Devices</h2>
    </div>
    <img class="close-button" (click)="onCancel()" src="assets/images/close-circle.svg">
    <!-- <button mat-icon-button (click)="onCancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button> -->
  </div>

  <div class="dialog-content" style="padding: 18px;">
    <form class="dialog-form">
      <h2 class="chosedev">Choose Devices</h2>
      <h4 class="maninp">Add devices to manually input readings</h4>

      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Select Devices</mat-label>
        <mat-select [(ngModel)]="selectedDevice" name="selectedDevice">
          
          <!-- This part shows the selected value (icon + title) in the input box -->
          <mat-select-trigger>
            <i [class]="selectedDevice?.image[0]" [style]="selectedDevice?.image[1]"></i>
            <span class="device-label"> {{ selectedDevice?.title }}</span>
          </mat-select-trigger>

          <!-- Dropdown options -->
          <mat-option *ngFor="let device of device_names" [value]="device">
            <span class="device-option">
              <i [class]="device.image[0]" [style]="device.image[1]"></i>
              <span class="device-label">{{ device.title }}</span>
            </span>
          </mat-option>
        </mat-select>
    </mat-form-field>

    </form>
  </div>

  <div class="dialog-actions2">
    <button mat-stroked-button color="primary" (click)="onCancel()">Cancel</button>
    <button mat-flat-button color="primary" (click)="onSave()">Save</button>
  </div>
</div>
